module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/016.77db78b0.png";